import { useState } from 'react';
import { useSelector } from 'react-redux';
import { GetPreSigendURL } from "../../services";
import { LanguageLoader } from "../../assets/languages";

const UploadVideo = () => 
{
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [file, setFile] = useState(null);
	const [uploading, setUploading] = useState(false);
	const [message, setMessage] = useState('');

	const handleChange = (e) =>
	{
		const selectedFile = e.target.files[0];
		const allowedTypes = ['video/mp4', 'video/x-m4v', 'video/webm'];	
		if (!allowedTypes.includes(selectedFile.type)) 
		{
			setMessage(language.ERROR.ONLY_VIDEO_TYPE_ALLOWED);
			return;
		}
		setFile(selectedFile);
		setMessage('');
	}

	const handleUpload = async () => 
	{
		if (!file) 
		{
			setMessage(language.ERROR.CHOOSE_A_FILE);			
	 		return;
		}
		setUploading(true);
		setMessage(language.PENDING_TO_GET_URL_FROM_SERVER);
		try
		{
			const data = { fileName:file.name }
			const APIResponse = await GetPreSigendURL(data);
	 		setMessage(language.UPLOADING_IN_S3);
			const uploadRes = await fetch(APIResponse.url, {
				method: 'PUT',
				headers: {
					'Content-Type': file.type || 'application/octet-stream'
				},
				body: file
	  		});
			if (uploadRes.ok) 
			{
				setMessage(language.UPLOAD_SUCCESSFUL);
	  		} 
			else
			{
				throw new Error(language.ERROR.ERROR_IN_UPLOAD);
			}
		} 
		catch (error) 
		{
			console.error(error);
			setMessage(error.message);
		}
		setUploading(false);
	};

	return (
		<div>
			<h4>📤 آپلود ویدئو به S3</h4>
			<input type="file" accept="video/mp4,video/x-m4v,video/*" onChange={handleChange} />
			<button className='btn-primary' onClick={handleUpload} disabled={uploading}>
				{uploading ? language.UPLOADING : language.UPLOAD}
			</button>
			<p className={`text-sm font-medium mt-4 ${uploading ? 'text-info' : 'text-success'}`}>
				{message}
			</p>
		</div>
	);
};

export default UploadVideo;
